import { createSelector } from 'reselect'

const selectSearch = state => state.search

export const selectSuggestions = createSelector(
  selectSearch,
  search => search.suggestions
)




// WEBPACK FOOTER //
// ./src/containers/ESSearch/selectors.js